import DrawerHeaderStyled from "./DrawerHeaderStyled";
import { useTheme } from "@mui/material";

const DrawerHeader = ({ open }: { open: boolean }) => {
    const theme = useTheme();
    return (
        <DrawerHeaderStyled theme={theme} open={open}>

        </DrawerHeaderStyled>
    );
}

export default DrawerHeader;